/** A single feature tile. Icon is a string key so content can come from a CMS. */
export type FeatureItem = {
  /** Maps to an entry in `featureIconMap`. Falls back to `Monitor` if unknown. */
  iconName: string;
  title: string;
  desc: string;
};

/** Default feature tiles shown in the login page left panel. */
export const defaultFeatures: FeatureItem[] = [
  {
    iconName: "vecta",
    title: "Powered by Vecta",
    desc: "Vecta is now Klipboard CRM. Same product, new name.",
  },
  {
    iconName: "users",
    title: "CRM",
    desc: "Manage customer relationships, contacts and interactions end-to-end.",
  },
  {
    iconName: "trendingUp",
    title: "Sales Analysis",
    desc: "Track pipeline, measure performance and uncover opportunities.",
  },
  {
    iconName: "barChart2",
    title: "Business Intelligence",
    desc: "Powerful BI dashboards and reporting to drive smarter decisions.",
  },
];
